module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"no_orders_to_review":"작성 가능한 주문이 없습니다.","confirm_cancel_review":"리뷰 작성을 취소하시겠습니까?\\n지금 취소하면 작성한 내용이 모두 삭제됩니다."}}')
  delete Component.options._Ctor
}
